import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import './AuthScreen.css';

const SignInScreen: React.FC = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { signIn, signInWithGoogle } = useAuth();
  const { theme } = useTheme();
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await signIn(formData.email, formData.password);
    
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error || 'Failed to sign in');
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-container" style={{ backgroundColor: theme.colors.background }}>
      <div className="auth-card" style={{ backgroundColor: theme.colors.surface }}>
        <div className="auth-header">
          <h1 style={{ color: 'var(--shared-primary)' }}>Welcome Back</h1>
          <p>Sign in to continue your sports journey</p>
        </div>

        {error && (
          <div className="error-message" style={{ backgroundColor: theme.colors.error + '20', color: theme.colors.error }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{ 
                borderColor: theme.colors.border,
                backgroundColor: theme.colors.background,
                color: theme.colors.text
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{ 
                borderColor: theme.colors.border,
                backgroundColor: theme.colors.background,
                color: theme.colors.text
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="auth-button"
            style={{ 
              backgroundColor: 'var(--shared-primary)',
              color: theme.colors.surface
            }}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>

          <div className="auth-divider">or</div>
          <button
            type="button"
            disabled={loading}
            className="auth-button auth-button-google"
            onClick={async () => {
              setError('');
              setLoading(true);
              const result = await signInWithGoogle();
              if (result.success) navigate('/');
              else setError(result.error || 'Google sign-in failed');
              setLoading(false);
            }}
          >
            Sign in with Google
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Don't have an account?{' '}
            <Link to="/signup" style={{ color: 'var(--shared-primary)' }}>
              Create Account
            </Link>
          </p>
          <p>
            <Link to="/forgot-password" style={{ color: theme.colors.secondary }}>
              Forgot Password?
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignInScreen;



